import logoStripUrl from '@/assets/misc/img_logos.svg'
import { Button } from '@/components/Button'
import { StyledLink } from '@/components/Link'
import { ButtonGroup } from '@/components/ButtonGroup'
import * as AppLinks from '@/consts/AppLinks'
import styles from './LandingPage.module.css'
import { formatUSPhoneNumber } from '@/utils/phone-number-util'

const YEAR = new Date().getFullYear()

export interface LandingPageViewProps {
  logoUrl: string
  logoAlt: string
  isPending: boolean
  onLogin: () => void
  onSignup: () => void
  testId?: string
  signInButtonTestId?: string
  createAccountButtonTestId?: string
  callCenterNumber?: string
  callCenterHours?: string
}

export function LandingPageView({
  logoUrl,
  logoAlt,
  isPending,
  onLogin,
  onSignup,
  testId,
  signInButtonTestId,
  createAccountButtonTestId,
  callCenterHours,
}: LandingPageViewProps) {
  const callCenterConfig =
    window.__workspaceDomain?.workspace?.config?.call_center_config

  return (
    <div className={styles.root} data-test={testId}>
      <div className={styles.main}>
        <div className={styles.mainContent}>
          <img className={styles.logo} src={logoUrl} alt={logoAlt} />
          <h1 className={styles.title}>File your taxes online</h1>
          <p className={styles.description}>
            Connect with a tax expert who'll do your taxes, so you won't have
            to.
          </p>

          {callCenterConfig?.enabled && callCenterConfig?.phone_number && (
            <p className={styles.phoneNumber}>
              Call us to get started.
              <br />
              {callCenterHours}
              <br />
              <StyledLink
                href={`tel:${callCenterConfig.phone_number}`}
                target="_self"
              >
                {formatUSPhoneNumber(callCenterConfig.phone_number)}
              </StyledLink>
            </p>
          )}

          <ButtonGroup stacked stretch>
            <Button
              label="Sign in"
              onPress={onLogin}
              isDisabled={isPending}
              testId={signInButtonTestId}
            />
            <Button
              variant="outline"
              label="Create an account"
              onPress={onSignup}
              isDisabled={isPending}
              testId={createAccountButtonTestId}
            />
          </ButtonGroup>

          <p className={styles.appInstructions}>
            Get the app on{' '}
            <StyledLink target="_blank" href={AppLinks.iOS}>
              iOS
            </StyledLink>
            ,{' '}
            <StyledLink target="_blank" href={AppLinks.Android}>
              Android
            </StyledLink>
            ,
          </p>
        </div>
        <div className={styles.copyright}>
          Copyright &copy; Tickmark, Inc {YEAR}
        </div>
      </div>

      <div className={styles.boast}>
        <div className={styles.boastContent}>
          <p className={styles.boastText}>
            25,000 companies & people like you connect with Taxfyle's Pro
            network for accounting services.
          </p>
          <img
            src={logoStripUrl}
            className={styles.boastLogos}
            alt="Logos of BDO, Forbes, Inc500, and VentureBeat."
          />
        </div>
      </div>
    </div>
  )
}
